import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

export default class MicAndCamPermissionSteps extends Component {
  render() {
    const { show, onHide } = this.props;
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Steps to give access of mic and camera to join your session:</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this._showMsgOrImage()}
        </Modal.Body>
        <Modal.Footer>
          <button 
            className="btn btn-primary"
            onClick={onHide}
          >
            ok
          </button>
        </Modal.Footer>
      </Modal>
    )
  };

  _showMsgOrImage = () => {
    let { browserName = "", isMobileDevice, iPad13, osName = "", orientation } = this.props;

    browserName = browserName.toLowerCase();
    osName = osName.toLowerCase();

    const onIpadOriOS = osName.includes("ios") || iPad13;

    if (onIpadOriOS) {
      return (<h4>Kindly refresh the page and click "Allow" when prompted to allow the access of camera and mic.</h4>);
    }

    if (browserName.includes("chrome")) {
      if (isMobileDevice) {
        if (orientation === "portrait") {
          return (<img src="/images/permission_chrome_mobile_portrait.jpg" className="img" />);
        }
        else {
          return (<img src="/images/permission_chrome_mobile_landscape.jpg" className="img" />);
        }
      }
      else {
        return (<img src="/images/permission_chrome_desktop.jpg" className="img" />);
      }
    }
    else if (browserName.includes("safari")) {
        return (<img src="/images/permission_safari_desktop.jpg" className="img" />);
    }
    else if (browserName.includes("firefox")) {
      if (isMobileDevice) {
        return null;
      }
      else {
        return (<img src="/images/permission_firefox_desktop.jpg" className="img" />);
      }
    }

    return null;
  }
}
